import React from 'react';
// import {Carousel} from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import {Testimonial} from "../../components/testimonial/Testimonial";

const TestimonialSlider = () => {

    const contentStyle = {
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
        
    };
    return (
        <div className="testimonial-container-background">
        <Carousel >
                <Testimonial
                    title={'Uncover the Voices of Our Satisfied Clients!'}
                    description={'“We in MyIndicators have had a very fruitful collaboration with Sprintly in development of Myli, a digital platform for behaviour change. Spritly is very encouraging to collaborate with. In addition to highly skilled frontend developers they are also highly involved in the design of new areas and managing in scrum master process. Also super engaged and loyal and do everything to meet deadlines."'}
                    nameof={'Patrik Helenius, Cofounder at MyIndicators'}
                />
                <Testimonial
                    title={'Uncover the Voices of Our Satisfied Clients!'}
                    description={'“Sprintly has been such a pleasure to work with. They quickly and fairly solve any issues we may have. The developers are higly skilled and hard working. From a client satisfaction standpoint, the cooperation and dedicated resources have done so much of work”'}
                    nameof={'Malene Schmidt, Cofounder at Myli'}
                />
        </Carousel>
        </div>

    )
}
export default TestimonialSlider;
